import referralRevenueSaga from 'features/revenue/referral/referralRevenueSaga';
import referralDetailSaga from 'features/revenue/referral/referralDetailSaga';
import referralMonthlyPayoutSaga from 'features/revenue/referral/referralMonthlyPayoutSaga';
import { all, fork } from 'redux-saga/effects';

export default function* referralSaga() {
  yield all([
    fork(referralRevenueSaga),
    fork(referralDetailSaga),
    fork(referralMonthlyPayoutSaga),
  ]);
}
